import { Box } from "@mui/material";

/**
 * Small "Beta" pill shown beside a nav item's label. Colours come from the nav
 * CSS variables the drawer declares, so the badge tracks the accent in both
 * themes without restating any palette values.
 */
const NavBetaBadge = () => (
  <Box
    component="span"
    sx={{
      flexShrink: 0,
      px: "6px",
      py: "1px",
      borderRadius: "999px",
      bgcolor: "var(--nav-item-active-bg)",
      color: "var(--nav-item-icon-active-color)",
      fontSize: 9.5,
      fontWeight: 700,
      lineHeight: "14px",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
    }}
  >
    Beta
  </Box>
);

export default NavBetaBadge;
